var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Mongodb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface61177637"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42 17.300781 C 42 37.800781 24 44 24 44 C 24 44 6 37.800781 6 17.300781 C 6 14.800781 6.199219 12.699219 6.398438 11 C 6.699219 8.5 8.398438 6.5 10.800781 5.898438 C 13.898438 5 18.800781 4 24 4 C 29.199219 4 34.101562 5 37.300781 5.898438 C 39.699219 6.5 41.398438 8.601562 41.699219 11 C 41.800781 12.699219 42 14.898438 42 17.300781 Z M 42 17.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.156864%,13.333334%,81.568629%)",
      fillOpacity: 1
    },
    d: "M 24 7 C 28.898438 7 33.5 8 36.5 8.800781 C 37.699219 9.101562 38.5 10.101562 38.699219 11.398438 C 38.898438 13.300781 39 15.300781 39 17.300781 C 39 32.898438 27.5 39.199219 24 40.699219 C 20.5 39.101562 9 32.800781 9 17.300781 C 9 15.300781 9.101562 13.300781 9.300781 11.398438 C 9.398438 10.101562 10.300781 9.101562 11.5 8.800781 C 14.5 8 19.101562 7 24 7 M 24 4 C 18.800781 4 13.898438 5 10.699219 5.898438 C 8.398438 6.5 6.601562 8.601562 6.398438 11 C 6.199219 12.699219 6 14.898438 6 17.300781 C 6 37.800781 24 44 24 44 C 24 44 42 37.800781 42 17.300781 C 42 14.800781 41.800781 12.699219 41.601562 11 C 41.300781 8.5 39.601562 6.5 37.199219 5.898438 C 34.101562 5 29.199219 4 24 4 Z M 24 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.156864%,13.333334%,81.568629%)",
      fillOpacity: 1
    },
    d: "M 23 28 L 25 28 L 25 36 L 23 36 Z M 23 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.156864%,13.333334%,81.568629%)",
      fillOpacity: 1
    },
    d: "M 24 10 C 24 10 18 15 18 23 C 18 28.199219 21.300781 31.5 23 33 L 24 30 L 25 33 C 26.699219 31.5 30 28.199219 30 23 C 30 15 24 10 24 10 Z M 24 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.156864%,13.333334%,81.568629%)",
      fillOpacity: 1
    },
    d: "M 24 10 C 24 10 18 15 18 23 C 18 28.199219 21.300781 31.5 23 33 L 24 30 Z M 24 10 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mongodb);
export default __webpack_public_path__ + "static/media/icons8-mongodb.bbf6de1d16f0867a3478b4c666716e0a.svg";
export { ForwardRef as ReactComponent };